"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _react = _interopRequireDefault(require("react"));

var _AdaptiveCardRenderer = _interopRequireDefault(require("./AdaptiveCardRenderer"));

var _adaptivecards = require("adaptivecards");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function stripSubmitAction(card) {
  if (!card.actions) {
    return card;
  } // Filter out HTTP action buttons


  var nextActions = card.actions.filter(function (action) {
    return action.type !== 'Action.Submit';
  }).map(function (action) {
    return action.type === 'Action.ShowCard' ? _objectSpread({}, action, {
      card: stripSubmitAction(action.card)
    }) : action;
  });
  return _objectSpread({}, card, {
    nextActions: nextActions
  });
}

var AdaptiveCardAttachment =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AdaptiveCardAttachment, _React$Component);

  function AdaptiveCardAttachment(props) {
    var _this;

    _classCallCheck(this, AdaptiveCardAttachment);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AdaptiveCardAttachment).call(this, props));
    _this.createAdaptiveCard = (0, _memoizeOne.default)(function (adaptiveCards, content, renderMarkdown) {
      var card = new adaptiveCards.AdaptiveCard();
      var errors = []; // TODO: [P3] Move from "onParseError" to "card.parse(json, errors)"

      adaptiveCards.AdaptiveCard.onParseError = function (error) {
        return errors.push(error);
      };

      card.parse(stripSubmitAction(_objectSpread({
        version: '1.0'
      }, content)));
      _adaptivecards.AdaptiveCard.onParseError = null;
      return {
        card: card,
        errors: errors
      };
    });
    return _this;
  }

  _createClass(AdaptiveCardAttachment, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          adaptiveCards = _this$props.adaptiveCards,
          attachment = _this$props.attachment,
          renderMarkdown = _this$props.renderMarkdown;

      var _this$createAdaptiveC = this.createAdaptiveCard(adaptiveCards, attachment.content, renderMarkdown),
          card = _this$createAdaptiveC.card;

      return _react.default.createElement(_AdaptiveCardRenderer.default, {
        adaptiveCard: card
      });
    }
  }]);

  return AdaptiveCardAttachment;
}(_react.default.Component);

exports.default = AdaptiveCardAttachment;